import { Container } from 'inversify';
import { DI_CONTAINER } from '../di-container';

export class ObservabilityUiModule {
  static initialize(container: Container) {
    DI_CONTAINER.merge(container);
  }
}
